import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "k-checkbox-label",
  for: "inputId"
}, null, -1)
const _hoisted_4 = {
  key: "'g' + cellProps.columnIndex",
  class: /*#__PURE__*/_normalizeClass('k-group-cell')
}
const _hoisted_5 = ["colSpan"]
const _hoisted_6 = { class: "k-reset" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_checkbox = _resolveComponent("k-checkbox")!

  return (_ctx.renderCell)
    ? (_openBlock(), _createElementBlock("td", {
        key: 0,
        class: _normalizeClass(_ctx.cellProps.className)
      }, [
        (_ctx.cellProps.field !== 'selected')
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.getNestedValue(_ctx.cellProps.field, _ctx.cellProps.dataItem)), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(_component_k_checkbox, {
                checked: _ctx.getNestedValue(_ctx.cellProps.field, _ctx.cellProps.dataItem),
                id: _ctx.inputId,
                onChange: _ctx.handleOnChange
              }, null, 8, ["checked", "id", "onChange"]),
              _hoisted_3
            ]))
      ], 2))
    : (_ctx.renderArrow)
      ? (_openBlock(), _createElementBlock("td", _hoisted_4))
      : (_ctx.cellProps.columnIndex <= _ctx.cellProps.level)
        ? (_openBlock(), _createElementBlock("td", {
            key: "g-colspan",
            colSpan: _ctx.cellProps.columnsCount - _ctx.cellProps.columnIndex
          }, [
            _createElementVNode("p", _hoisted_6, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
                tabindex: "-1",
                href: "#",
                class: _normalizeClass(_ctx.cellProps.expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon')
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.column.title) + ":  ", 1),
              (_ctx.renderCellComponent)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.renderCellComponent), {
                      dataItem: _ctx.cellProps.dataItem,
                      field: _ctx.cellProps.field,
                      rowType: _ctx.cellProps.rowType,
                      value: _ctx.renderValue,
                      format: _ctx.format,
                      isGroupRender: true
                    }, null, 8, ["dataItem", "field", "rowType", "value", "format"]))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.renderValue), 1))
            ])
          ], 8, _hoisted_5))
        : _createCommentVNode("", true)
}